// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { threeDotsLine16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-three-dots-line': IconThreeDotsLine;
    }
}

/**
 * The icon component for the 'threeDotsLine' icon
 */
export class IconThreeDotsLine extends IconSvg {
    public constructor() {
        super(threeDotsLine16X16);
    }
}

registerIconSvg('icon-three-dots-line', IconThreeDotsLine);
export const iconThreeDotsLineTag = 'nimble-icon-three-dots-line';
